import { Content, Flex, fromTheme, usePlatformInfo } from '@acsbe/ui';
import styled from 'styled-components';
import {
  APPLICATION_MODES,
  useApplicationViewState,
  useDomainSelection,
} from '../../context';
import { CmsIconImg } from '../authentication/modalFlow/cms-icon';
import { LimitedAccessBanner } from '../root/subscription/limited-access-banner';
import { FlyoutActionMenu } from './flyout-action-menu';
import { WidgetStatusBadge } from './widget-status-badge';

const DashboardHeader = () => {
  const { licenseDetails } = useDomainSelection();
  const { applicationMode } = useApplicationViewState();
  const { isPhablet, isMobile } = usePlatformInfo();
  return (
    <Flex
      style={{
        backgroundColor: '#FFFFFF',
        padding:
          applicationMode === APPLICATION_MODES.LIMITED ? '24px' : '16px 24px',
        borderRadius: '12px',
        border: '1px solid #CBD2E1',
        flexWrap: 'wrap',
        gap: applicationMode === APPLICATION_MODES.LIMITED ? '24px' : '8px',
      }}
    >
      <Flex row={!isPhablet && !isMobile} justify="space-between" gap={2}>
        <Flex row gap={3}>
          <CmsIconImg />
          <Flex
            style={{
              justifyContent: 'center',
              flexDirection: 'column',
              height: '48px',
            }}
          >
            <DomainName>{licenseDetails?.domain}</DomainName>
          </Flex>
        </Flex>
        <Flex row gap={4} align="center">
          <WidgetStatusBadge />
          {applicationMode === APPLICATION_MODES.LIMITED ? (
            <FlyoutActionMenu />
          ) : null}
        </Flex>
      </Flex>
      {applicationMode === APPLICATION_MODES.LIMITED ? (
        <LimitedAccessBanner />
      ) : null}
    </Flex>
  );
};

const DomainName = styled(Content)`
  font-size: 22px;
  font-weight: 600;
  word-break: break-all;
  @media ${fromTheme('viewport.uptoMobile')} {
    font-size: 18px;
  }
`;
export { DashboardHeader };
